import Vue from 'vue'

import {
  Breadcrumb,
  BreadcrumbItem,
  Tabs,
  TabPane,
  Pagination,
  Input,
  Button,
  Select,
  Form,
  FormItem,
  Option,
  Message,
  Popover,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Loading,
  Dialog,
  Upload,
  DatePicker,
  MessageBox,
  Menu,
  Submenu,
  MenuItem,
  MenuItemGroup,
  Radio,
  RadioGroup,
  Icon,
  Checkbox,
  Carousel
} from 'element-ui'

export const message = (...args) => {
  if (!process.server) {
    Message(...args)
  }
}

export default (() => {
  Vue.use(Breadcrumb)
  Vue.use(BreadcrumbItem)
  Vue.use(Tabs)
  Vue.use(TabPane)
  Vue.use(Pagination)
  Vue.use(Input)
  Vue.use(Button)
  Vue.use(Select)
  Vue.use(Form)
  Vue.use(FormItem)
  Vue.use(Option)
  Vue.use(Dropdown)
  Vue.use(DropdownMenu)
  Vue.use(DropdownItem)
  Vue.use(Loading.directive)
  Vue.use(Popover)
  Vue.use(Dialog)
  Vue.use(Upload)
  Vue.use(DatePicker)
  Vue.use(Menu)
  Vue.use(Submenu)
  Vue.use(MenuItem)
  Vue.use(MenuItemGroup)
  Vue.use(Radio)
  Vue.use(RadioGroup)
  Vue.use(Icon)
  Vue.use(Checkbox)
  Vue.use(Carousel)
  Vue.prototype.$msgbox = MessageBox
  Vue.prototype.$alert = MessageBox.alert
  Vue.prototype.$confirm = MessageBox.confirm
  // Vue.prototype.$msg = Message
})()



// WEBPACK FOOTER //
// ./src/config/element-ui.js